import { useEffect } from 'react'

const useDocumentTitle = (baseTitle: string) => {
  useEffect(() => {
    const existingTitle = document.title
    if (baseTitle !== '') {
      const countMatch = existingTitle.match(/^\(\d+\)/)

      document.title = countMatch ? `${countMatch[0]} ${baseTitle}` : baseTitle
    }

    return () => {
      document.title = existingTitle
    }
  }, [baseTitle])
}

export default useDocumentTitle
